module.exports = __webpack_public_path__ + "img/logo-copa-2025.3acf8c94.png";